import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export const NoImage = () => {
  return (
    <div className={styles['image']}>
      <IconPlaceholderImages24 width={40} height={40} color="icon-secondary-default" />
    </div>
  );
};
